import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Tag from '@atlaskit/tag';
import { FilterClickedEvent, withAnalytics } from '@atlassian/mpac-analytics';
import { withFeatureFlags } from '@atlassian/mpac-feature-flags';
import { Set } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getFilters } from '../../../../../../common/config/filters';
import CommonPropTypes from '../../../../../../common/constants/proptypes/CommonPropTypes';
import { ANALYTICS_SUBJECT_ID_CURRENT_FILTER_X_REMOVE_ICON, EVENT_CHANNEL, EVENT_SOURCE, OBJECT_TYPE_FILTER } from '../../../../../constants/analytics/events';
import { SEARCH } from '../../../../../constants/perspectives';
class CurrentFilter extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "removeFilter", () => {
      const newFilters = this.props.multi ? this.props.filters.update(this.props.filterKey, Set(), f => f.remove(this.props.filterValue)) : this.props.filters.delete(this.props.filterKey);
      this.props.fireAnalyticsEvent({
        eventType: FilterClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_CURRENT_FILTER_X_REMOVE_ICON,
        objectType: OBJECT_TYPE_FILTER,
        objectId: this.props.filterKey,
        source: EVENT_SOURCE,
        attributes: {
          currentPerspective: SEARCH,
          filterValue: this.props.filterValue,
          selected: false
        }
      }, EVENT_CHANNEL);
      this.props.stateChangeRequested({
        filters: newFilters
      });
      return false;
    });
  }
  render() {
    // Must be wrapped in a span otherwise React invariant violations are thrown in non-Chrome browsers
    // (i.e. those that use the custom element polyfill)
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Tag, {
      text: this.resolveFilterText(),
      removeButtonLabel: "Remove filter",
      onBeforeRemoveAction: this.removeFilter
    }));
  }
  resolveFilterText() {
    const {
      filterKey,
      filterValue
    } = this.props;
    const filter = getFilters().get(filterKey);
    return filter.get('resolveCurrentFilterText') ? filter.get('resolveCurrentFilterText')({
      value: filterValue
    }) : filter.get('custom') ? filter.getIn(['customFilters', this.props.filterValue]).get('label') : this.props.filterValue;
  }
}
_defineProperty(CurrentFilter, "propTypes", {
  fireAnalyticsEvent: PropTypes.func.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  filterKey: PropTypes.string.isRequired,
  filterValue: PropTypes.string.isRequired,
  multi: PropTypes.bool.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
});
export default withAnalytics(withFeatureFlags(CurrentFilter));